import React, { useRef,useState, useEffect } from 'react';
// import { useDebounce } from 'use-debounce';

export function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Return a cleanup function that will be called every time ...
      // ... useEffect is re-called. useEffect will only be re-called ...
      // ... if value changes (see the inputs array below). 
      // This is how we prevent debouncedValue from changing if value is ...
      // ... changed within the delay period. Timeout gets cleared and restarted.
      // To put it in context, if the user is typing within our app's ...
      // ... search box, we don't want the debouncedValue to update until ...
      // ... they've stopped typing for more than 500ms.
      return () => {
        clearTimeout(handler);
      };
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value] 
  );
  return debouncedValue;
}

const BarRecherche = ({ texte_recherche, rechEcole }) => {
  const inputRef = useRef(null);
  const [text, setText] = useState('');
  //const [value] = useDebounce(text, 300);

  const handleSearch=(t)=>{
      setText(t)
     // rechEcole(value)
  }

  const debouncedSearchTerm = useDebounce(text, 400);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(
    () => {
      // Make sure we have a value (user has entered something in input)
      if (debouncedSearchTerm) {
        rechEcole(debouncedSearchTerm)
      } 
    },
    // This is the useEffect input array
    // Our useEffect function will only execute if this value changes ...
    // ... and thanks to our hook it will only change if the original ...
    // value (searchTerm) hasn't changed for more than 500ms.
    [debouncedSearchTerm]
  );
  return (
    <div>
      <div className='container justify-content-center mt-4'>
        <div className='row'>
          <div className='col-sm-12'>
            <form autoComplete='off' className='form-recheche-Ecole' noValidate>
              <div className='row'>
                <div className='col-sm-12 mb-4'>
                  <div className='border rounded p-3'>
                    <input
                      type='text'
                      id='inputRechecheEcole'
                      ref={inputRef}
                      className='form-control font-weight-normal text-center'
                      placeholder="Entrer le nom de l'ecole"
                      required=''
                      autoFocus={true}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
                {/* <div className='col-sm-2 mb-4'>
                  <button className='btn btn-primary btn-block' type='submit'>
                    Rech..
                  </button>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarRecherche;
